export interface KanbanViewHeaderI {
    title: string;
    name: string;
    position: number;
    duration: string;
    dropOff: string;
    dropOffHour: string;
}

export interface KanbanViewCardI {
    select: boolean;
    id: string;
    title: string;
    accountName: string;
    contactName: string;
    created: string;
    phone: string;
    email: string;
}

export interface KanbanViewListI {
    id: string;                     
    header: KanbanViewHeaderI,
    cards: KanbanViewCardI[]; 
}
